import { Box, createStyles, IconButton, makeStyles } from '@material-ui/core'
import { ImagePreview } from '../../../shared/ui/imagePreview'
import AddIcon from '@material-ui/icons/Add'
import CheckIcon from '@material-ui/icons/Check'

interface MarketplaceImageItemProps {
  image: {id: string; url: string; name: string}

  isAdded: boolean

  onAdd: () => void

  isMain?: boolean
}

export const MarketplaceImageItem = ({image, isAdded, onAdd, isMain}: MarketplaceImageItemProps) => {
  const classes = useStyles()

  return (
    <Box className={classes.wrapper}>
      <ImagePreview
        url={image.url}
        name={image.name}
        isMain={isMain}
      />

      {!isAdded && (
        <IconButton
          onClick={onAdd}
          color="secondary"
          style={{
            position: 'absolute',
            top: 10,
            right: 10,
            padding: 0,
            backgroundColor: '#f5f8ff'
          }}
        >
          <AddIcon fontSize="small"/>
        </IconButton>
      )}

      {isAdded && (
        <IconButton
          style={{
            position: 'absolute',
            top: 10,
            right: 10,
            padding: 0,
            backgroundColor: '#b8fdc2',
            cursor: 'default'
          }}
        >
          <CheckIcon fontSize="small"/>
        </IconButton>
      )}
    </Box>
  )
}

const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      height: '200px',
      position: 'relative'
    }
  }))